export default __webpack_public_path__ + "static/media/004-action camera.4654ddab.svg";